<div class="flex center gap-1">
  <button
    mat-button
    class="appear-horizontal me-3"
    type="button"
    (click)="onCancel()"
  >
    <mat-icon>arrow_back</mat-icon>
  </button>
  <h1>{{ merchantName }}</h1>
</div>
<nav class="easy-tab" mat-tab-nav-bar [tabPanel]="tabPanel">
  <a
    mat-tab-link
    *ngFor="let link of navLinks"
    [routerLink]="link.link"
    [replaceUrl]="true"
    routerLinkActive
    #rla="routerLinkActive"
    [active]="rla.isActive"
    queryParamsHandling="preserve"
  >
    {{ link.label | async }}
  </a>
</nav>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
